import React from "react";

export function PrainhaGrumari() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-name="Camada 1"
    viewBox="0 0 60 60"
  >
    <defs>
      <linearGradient
        id="a"
        x1={13.78}
        x2={9.34}
        y1={52.23}
        y2={45.9}
        data-name="Gradiente sem nome 7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="b"
        x1={22.44}
        x2={18.01}
        y1={56.56}
        y2={50.23}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="c"
        x1={41.52}
        x2={37.08}
        y1={56.56}
        y2={50.23}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="d"
        x1={31.98}
        x2={27.55}
        y1={52.23}
        y2={45.9}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="e"
        x1={50.19}
        x2={45.75}
        y1={52.23}
        y2={45.9}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="f"
        x1={45.31}
        x2={11.82}
        y1={53.82}
        y2={6}
        data-name="Gradiente sem nome 7"
      />
    </defs>
    <path
      d="M17.34 49.66a.8.8 0 0 0 .26-.61c0-.52-.35-.87-.87-.87-.26 0-.43.09-.61.26 0 0-.78.61-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.35 0-1.13-.61-1.13-.61-.35-.35-.87-.35-1.21 0s-.35.87 0 1.21c.61.61 1.47 1.04 2.34 1.13.61 0 1.21-.26 1.73-.61.52.35 1.13.61 1.73.61s1.21-.26 1.73-.61c.52.35 1.13.61 1.73.61.87-.09 1.73-.52 2.34-1.13Z"
      style={{
        fill: "url(#a)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M25.41 52.52c-.26 0-.43.09-.61.26 0 0-.78.61-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.35 0-1.13-.61-1.13-.61-.35-.35-.87-.35-1.21 0s-.35.87 0 1.21c.61.61 1.47 1.04 2.34 1.13.61 0 1.21-.26 1.73-.61.52.35 1.13.61 1.73.61s1.21-.26 1.73-.61c.52.35 1.13.61 1.73.61.87-.09 1.73-.52 2.34-1.13a.8.8 0 0 0 .26-.61c0-.52-.35-.87-.87-.87Z"
      style={{
        fill: "url(#b)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M44.48 52.52c-.26 0-.43.09-.61.26 0 0-.78.61-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.35 0-1.13-.61-1.13-.61-.35-.35-.87-.35-1.21 0s-.35.87 0 1.21c.61.61 1.47 1.04 2.34 1.13.61 0 1.21-.26 1.73-.61 1.04.87 2.43.87 3.47 0 .52.35 1.13.61 1.73.61.87-.09 1.73-.52 2.34-1.13a.8.8 0 0 0 .26-.61c0-.52-.35-.87-.87-.87Z"
      style={{
        fill: "url(#c)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M35.55 49.66a.8.8 0 0 0 .26-.61c0-.52-.35-.87-.87-.87-.26 0-.43.09-.61.26 0 0-.78.61-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.35 0-1.13-.61-1.13-.61-.35-.35-.87-.35-1.21 0s-.35.87 0 1.21c.61.61 1.47 1.04 2.34 1.13.61 0 1.21-.26 1.73-.61.52.35 1.13.61 1.73.61s1.21-.26 1.73-.61c.52.35 1.13.61 1.73.61.87-.09 1.73-.52 2.34-1.13Z"
      style={{
        strokeWidth: 0,
        fill: "url(#d)",
      }}
    />
    <path
      d="M53.15 48.18c-.26 0-.43.09-.61.26 0 0-.78.61-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.43-.09-.78-.26-1.13-.61l-.61-.61-.61.61c-.35.35-.69.52-1.13.61-.35 0-1.13-.61-1.13-.61-.35-.35-.87-.35-1.21 0s-.35.87 0 1.21c.61.61 1.47 1.04 2.34 1.13.61 0 1.21-.26 1.73-.61 1.04.87 2.43.87 3.47 0 .52.35 1.13.61 1.73.61.87-.09 1.73-.52 2.34-1.13a.8.8 0 0 0 .26-.61c0-.52-.35-.87-.87-.87Z"
      style={{
        fill: "url(#e)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M46.21 27.98c.69.43 1.47.78 2.25.95.43.17.78.17 1.21.17 1.21 0 2.34-.35 3.29-1.04 1.39-.87 2.25-2.25 2.6-3.81s0-3.21-.87-4.59a6.794 6.794 0 0 0-2.34-2.08c.95-1.47.95-3.47-.17-5.03-.61-.87-1.56-1.39-2.6-1.65v-.87c0-2.6-1.3-5.2-4.33-5.2-4.68 0-5.2 2.95-5.2 5.2 0 .43.17.87.35 1.21-1.21.69-1.99 2.08-1.99 3.99 0 .78.17 1.47.52 2.08-2.51.95-4.25 3.47-3.99 6.33.35 3.29 3.29 5.81 6.59 5.46 1.04-.09 1.99-.52 2.86-1.04v6.24h-4.42c-3.64 0-7.2.95-10.32 2.77-3.03-1.73-6.68-2.77-10.4-2.77h-6.07v-7.63c1.73 1.04 3.99.95 5.72-.26 2.34-1.73 2.77-4.94 1.13-7.28-.35-.43-.69-.78-1.13-1.13.35-.69.52-1.47.43-2.34-.09-1.13-.69-2.17-1.56-2.86a5.51 5.51 0 0 0-1.21-.69c.17-.69.26-1.47 0-2.25a4.161 4.161 0 0 0-1.99-2.69c-1.99-1.21-4.59-.61-5.9 1.47-.61 1.04-.78 2.25-.43 3.38-1.73.69-2.95 2.43-2.77 4.42.09.52.17 1.04.43 1.47-1.99 1.39-2.77 4.07-1.65 6.42.87 1.91 2.69 3.03 4.68 3.03.69 0 1.47-.17 2.17-.52.17-.09.26-.17.43-.26v7.72h-7.8v1.73h15.61c7.37 0 13.18 4.16 15.43 8.41-.52.17-1.04.26-1.56.26a9.296 9.296 0 0 1-3.12-.78l-.35-.17-.35.17c-.95.43-2.08.69-3.03.78a9.296 9.296 0 0 1-3.12-.78l-.43-.17-.35.17c-.95.43-2.08.69-3.03.78a9.296 9.296 0 0 1-3.12-.78l-.43-.17-.35.17c-.95.43-2.08.69-3.03.78a9.296 9.296 0 0 1-3.12-.78l-.43-.17-.35.17c-1.3.52-2.6.78-3.99.78h-.87v1.73h1.04c1.47 0 2.86-.26 4.16-.78 1.13.43 2.25.69 3.55.78 1.21-.09 2.34-.35 3.47-.78 1.13.43 2.25.69 3.47.78 1.21-.09 2.34-.35 3.47-.78 1.13.43 2.25.69 3.47.78 1.21-.09 2.34-.35 3.47-.78 1.13.43 2.25.69 3.47.78 1.21-.09 2.34-.35 3.47-.78 1.13.43 2.25.69 3.47.78 1.21-.09 2.34-.35 3.47-.78 1.13.43 2.25.69 3.47.78 1.21-.09 2.34-.35 3.47-.78 1.13.43 2.25.69 3.47.78h1.73V44.7h-1.73a9.296 9.296 0 0 1-3.12-.78l-.43-.17-.35.17c-.95.43-2.08.69-3.03.78a9.296 9.296 0 0 1-3.12-.78l-.43-.17-.35.17c-.95.43-2.08.69-3.03.78a9.296 9.296 0 0 1-3.12-.78l-.43-.17-.35.17c-1.13-2.25-2.86-4.16-4.94-5.72 2.69-1.39 5.64-2.08 8.67-2.08h15.69v-1.73h-9.54v-6.42Zm-4.76-.6c-2.43.26-4.51-1.47-4.77-3.9-.09-1.13.26-2.25.95-3.21.69-.87 1.73-1.47 2.95-1.56l2.08-.17-1.56-1.3c-.61-.52-.95-1.21-.95-1.99 0-.61.17-2.43 1.82-2.6l1.39-.17-.69-1.13c-.09-.17-.17-.35-.35-.43-.17-.35-.43-.69-.43-.87 0-2.17.61-3.47 3.47-3.47 2.51 0 2.6 2.86 2.6 3.47v2.6h.87c.78 0 1.56.35 2.08 1.04.87 1.13.61 2.77-.52 3.64l-1.47 1.13 1.82.43c1.04.26 1.99.87 2.6 1.82s.87 2.08.61 3.29-.87 2.08-1.82 2.77c-.95.61-2.08.87-3.29.61a4.002 4.002 0 0 1-2.6-1.65v-1.91l3.81-1.56c.43-.17.69-.69.43-1.13-.17-.43-.69-.69-1.13-.43l-3.12 1.13v-7.46c0-.52-.35-.87-.87-.87s-.87.35-.87.87v7.46l-3.12-1.3c-.43-.17-.95 0-1.13.43s0 .95.43 1.13l3.81 1.56v1.99c-.69.95-1.82 1.56-3.03 1.73ZM10.41 25.3c-.87.35-1.82.43-2.69.09s-1.56-.95-1.91-1.82-.43-1.82-.09-2.69.95-1.56 1.82-1.91l1.04-.43-.69-.87c-.35-.43-.52-.87-.52-1.39-.17-1.39.87-2.69 2.34-2.77l1.39-.17-.69-1.21c-.52-.87-.52-1.82 0-2.69.26-.69 1.13-1.13 1.99-1.13.43 0 .95.09 1.3.35.61.35 1.04.95 1.21 1.65s.09 1.39-.26 1.99l-.69 1.21 1.39.17c.52.09.95.26 1.39.52.52.43.87 1.04.95 1.73s-.09 1.39-.52 1.91l-.69.87 1.04.43c.52.26.95.61 1.3 1.04 1.13 1.56.78 3.73-.69 4.85-1.47 1.04-3.47.78-4.68-.52v-1.56l3.73-.78c.43-.09.78-.52.69-1.04a.899.899 0 0 0-1.04-.69l-3.55.69V16.1c0-.52-.35-.87-.87-.87s-.87.35-.87.87v5.03l-3.29-.69c-.43-.09-.95.17-1.04.69-.09.43.17.95.69 1.04l3.64.69v1.56c-.35.35-.69.69-1.13.87Z"
      style={{
        fill: "url(#f)",
        strokeWidth: 0,
      }}
    />
  </svg>
  );
}